/* eslint-disable arrow-body-style */

import { useMemo } from 'react';
import { Table, TableAddon } from 'tea-component';

import type { PageableOptions } from 'tea-component/es/table/addons';

const { pageable } = Table.addons;

interface IUseTablePageableOptionsAddon extends PageableOptions {
  loading?: boolean;
}

function getStateText(total?: any): string {
  let totalNum = Number.parseInt(total, 10);
  if (Number.isNaN(totalNum)) {
    totalNum = 0;
  }
  const itemText = totalNum > 1 ? 'items' : 'item';
  return `${totalNum} ${itemText} in total`;
}

export default function useTablePageableOptionsAddon<T = any>(props?: IUseTablePageableOptionsAddon) {
  const { loading = false, recordCount, pageSizeOptions, ...restProps } = props || {};

  const pageableAddon = useMemo<TableAddon<T>>(() => {
    const minPageSize = Math.min(...(pageSizeOptions || []));
    const isLessThanOnePage = !recordCount || recordCount <= minPageSize;

    return pageable({
      ...restProps,
      recordCount,
      stateText: getStateText(loading ? 0 : recordCount),
      pageSizeVisible: !loading && !isLessThanOnePage,
      pageSizeOptions,
      pageIndexVisible: !loading && !isLessThanOnePage,
      jumpVisible: !loading && !isLessThanOnePage,
      endJumpVisible: !loading && !isLessThanOnePage,
    });
  }, [loading, recordCount, pageSizeOptions, restProps]);

  return pageableAddon;
}
